<template>
  <div class="cont_evalua-root">
    <div class="item-wrap" v-for="(item) in contsList" :key="item.id">
      <span
        :class="['item', item.checked ? 'checked':'', isEdit?'':'not_edit']"
        @click="checkCont(item)"
      >{{item.text}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "EvaluaConts",
  props: {
    contsList: {
      type: Array
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    checkCont(item) {
      if (!this.isEdit) return;
      if (this.contsList.indexOf(item) === -1) return;
      item.checked = !item.checked;
      this.$emit("update:contsList", this.contsList);
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.cont_evalua-root
  display flex 
  width 100% 
  flex-flow row wrap 
  .item-wrap 
    width 25%
    .item
      display block
      width 170px
      height 34px
      padding 0 10px
      margin 0 auto 13px
      line-height @height
      color $color_info
      border 1px dashed $color_info
      text-align center
      cursor pointer
      over_hide()
      &.checked
        color: $color_white
        border 1px solid $rating_primary_color
        background-color $rating_primary_color
      &.not_edit
        cursor auto
</style>
